import { ListItemText, Stack, SvgIcon, SxProps } from "@mui/material";
import { EDecimalToHex, sphereColors } from "@styles/common-colors";
import { formatUserRoleType, userRoleDescription } from "@utils/data-display";
import GenericCheck from "@assets/icons/generic-check_l.svg?react";
import { addTransparency } from "@utils/ui-utils";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** The role to show */
  role: FaroCoreApiTypes.CompanyRole | FaroCoreApiTypes.ProjectRole;

  /** Whether the role is selected or not */
  isRoleSelected?: boolean;
}

/**
 * Provides the styling for the menu item that allows the user to select a role.
 */
export function getRoleMenuItemSx({
  isTableCell,
}: {
  isTableCell: boolean;
}): SxProps {
  return {
    "&.Mui-selected": {
      backgroundColor: addTransparency({
        color: sphereColors.gray500,
        alpha: EDecimalToHex.thirtyEight,
      }),
    },
    m: "8px",
    textWrap: "wrap",
    width: isTableCell ? "250px" : "undefined",
  };
}

/**
 * Shows the content for a menu item (an option to be selected) when changing roles via dropdown.
 */
export function RoleMenuItem({
  role,
  isRoleSelected = false,
}: Props): JSX.Element {
  return (
    <ListItemText
      key={role}
      sx={{
        "& .MuiListItemText-primary": {
          fontSize: "12px",
          fontWeight: 600,
        },
        "& .MuiListItemText-secondary": {
          fontSize: "11px",
          fontWeight: 400,
        },
      }}
      primary={
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
            color: isRoleSelected ? sphereColors.blue500 : "inherit",
          }}
        >
          {formatUserRoleType(role)}
          {isRoleSelected && (
            <SvgIcon
              inheritViewBox
              component={GenericCheck}
              sx={{
                height: "16px",
                width: "16px",
              }}
            />
          )}
        </Stack>
      }
      secondary={userRoleDescription(role)}
    />
  );
}
